import { Box, Divider, Flex, FormLabel, Image, Input, Select, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { AddVitalData, FetchPatientDetails, FetchVitalsDetails } from "../../middleware/services/messages";
import moment from "moment";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { useNavigate } from "react-router-dom";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import NoDataScreen from "../../components/patient-health/no-data-screen";
import { getIsDoctor, getLoginID } from "../../auth";
import ProfileVitalDisplayCard from "../../components/patientProfile-vital-display-card";
import { GetPatientHealthData } from "../../middleware/services/visits/patient-overview";
import NoDataVitalsScreen from "./no-data-vitals-screen";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import ModalRight from "../../components/modal-right";
import DatePicker from "../../components/date-picker";
import { FetchDoctorsByUser, FetchUsersByClinic } from "../../middleware/services/home";


const PatientVitalsIndex = ({id, backFunction, registerFetchFunction}) => {

  const [patientid, setPatientid] = useState("");
  const [appointmentId, setAppointmentId] = useState(null);
  const [Doctorid, setDoctorid] = useState("");
  const [isVitals, setIsVitals] = useState(false);
  const [vitalsData, setVitalsData] = useState(null);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  const navigate = useNavigate()
  useEffect(() => {
    // fetchvitaldata(id)  
    const loginid = getLoginID();
    setDoctorid(loginid); 

    // Parse the current URL
  const currentUrl = window.location.href;
  const urlParams = new URLSearchParams(currentUrl.split('?')[1]);
  
  // Get all parameters
  const id = urlParams.get('id');
  const getappointmentid = urlParams.get('appointmentid');

  setPatientid(id)
  if (getappointmentid) {
    setAppointmentId(getappointmentid); // Make sure you have this state defined
  }

  if(getappointmentid) {
    fetchpatientdata(id, getappointmentid)
    fetchvitaldata(id, getappointmentid)
  } else {
      fetchpatientdata(id, "")
      fetchvitaldata(id, "")
    }

  }, []);

  // useEffect(() => {
  //   if (patientid) {
  //   fetchvitaldata(patientid, appointmentId);
  // }

  // },[props.refreshTrigger, patientid, appointmentId])

  // Pass the function to the parent when component mounts
  useEffect(() => {
    if (registerFetchFunction) {
      registerFetchFunction(fetchvitaldata);
    }
  }, [registerFetchFunction]);

  const fetchpatientdata = async (id, apmtid="") => {
        setPatienData(null)
            try {
              const result = await FetchPatientDetails({
                patientid: id,
                ...(apmtid && { appointmentid: apmtid }), // Only include appointmentid if apmtid exists
                ...(apmtid && { type: 'ipd' })
              });
              console.log(result, "ressssssssss")
              if(result && result.patientinfo && result.patientinfo.countryid) {
                localStorage.setItem('patientCountryId', result.patientinfo.countryid)
          // setPatientCountryId(result.patientinfo.countryid)
        }
  
              if (result != null) {
                setPatienData(result);
              } else {
                setPatienData(null)
              }
              return result; // Add this line to return the data
          } catch (error) {
              console.error("Error in home:", error);
            }
          };

  
  const fetchvitaldata = async (id, apmtid="") => {
    showLoader()
        try {
          const result = await FetchVitalsDetails({
            patientid: id,
            ...(apmtid && { appointment_id: apmtid }), 
          ...(apmtid && { type: 'ipd' })
          });
          console.log('result fo the final result: ', result)

          if (result != null) {
          // if (result?.output?.result === 'success') {
            console.log('vitalData: ', result)
        //     if(appointmentId) {

        //       // was existing but commented 
        //       // Create formatted data structure similar to labs example
        // // const formattedVitalsData = {
        // //   rows: result.map((item) => ({
        // //     header: item.vitalname,
        // //     unit: item.vitalunit,
        // //     values: [{
        // //       resultvalue: item.vitalvalue,
        // //       documentdate: item.vitaladdeddate,
        // //       status: item.status,
        // //       // Adding these to match labs structure (null if not applicable)
        // //       upper_bound: null, 
        // //       lower_bound: null,
        // //       trendcolor: getTrendColor(item.status) // Helper function to map status to color
        // //     }],
        // //     // Additional fields to match labs structure
        // //     reportid: [null], // Not applicable for vitals
        // //     documetURL: [null], // Not applicable for vitals
        // //     reportname: [item.vitalname] // Using vital name as report name
        // //   }))
        // // };
        // // setVitalsData(formattedVitalsData)
  
        // setVitalsData(result);
        // setIsVitals(true);
        //     } else {
        //       setVitalsData(result);
        //       setIsVitals(false);

        //     }
        const hasVitalData = result && result.length > 0; 
      console.log(hasVitalData, 'has Voitalt Dat')
      setVitalsData(result);
      console.log('VTISASDFSDF: ', result)
      setIsVitals(hasVitalData); 
          } else {
            setVitalsData(null); // or empty array based on your needs
      setIsVitals(false);
          }
          dismissLoader()
      } catch (error) {
          console.error("Error in home:", error);
        }
      };

      // Helper function to map status to color (add this outside your component)
const getTrendColor = (status) => {
  switch(status.toLowerCase()) {
    case 'high': return 'red';
    case 'low': return 'blue';
    case 'normal': return 'green';
    default: return 'gray';
  }
};

  // const [inputData, setInputData] = useState({
  //     'patientid': patientid,
  //     // appointmentid: appointmentId,
  //     'doctorid': doctorid,
  //   });
  // // Function to fetch patient entire health data and update state - FOR PATIENT CURRENT VISIT
  // const fetchPatientHealthData = async () => {
  //   showLoader();
  //   try {
  //     const data = await GetPatientHealthData(inputData);
  //     // console.log(data);
  //     setVitalsData(data);
  //   } catch (error) {
  //     console.error("Error fetching patient health data:", error);
  //   } finally {
  //     dismissLoader();
  //   }
  // };

  /// Call fetchPatientHealthData function whenever inputData or formattedInput changes
  // useEffect(() => {
  //   setPatientid(id) 
  //   const loginid = getLoginID();
  //   setDoctorid(loginid); 
  //   fetchPatientHealthData();
  // }, [inputData]);

      const formatDate = (dateString) => {
        if (!dateString) return "-";
        return moment(dateString).format("Do MMM, YYYY");
      };

      // console.log(patientid, "allergy IDDDDD")
      // console.log(vitalsData, "allergy Dataaaaaaa")
    
// ----------------------------- Add Vitals Functionality Starts ----------------------------
    const addVitalData = useRef();
        const [patienData, setPatienData] = useState(null);
    
        const [patientHealthData, setPatientHealthData] = useState(null);    
            
          const [tempUnit, setTempUnit] = useState( "°F"
          );
          const [tempValue, setTempValue] = useState(""
          );
          const [error, setError] = useState("");
          // Temperature ranges in both units
  const MIN_TEMP_F = 89;
  const MAX_TEMP_F = 111;
  const MIN_TEMP_C = 31.7; // (89°F - 32) * 5/9 ≈ 31.7°C
  const MAX_TEMP_C = 43.9; // (111°F - 32) * 5/9 ≈ 43.9°C
    
          const [weightUnit, setWeightUnit] = useState('Standard'); // or 'Metric'
    const [heightUnit, setHeightUnit] = useState('Standard');
    
          // const [weightUnit, setWeightUnit] = useState( "lbs"
          // );
          const [weightValue, setWeightValue] = useState(""
          );
          // const [heightUnit, setHeightUnit] = useState("ft"
          // );
          const [heightValue, setHeightValue] = useState(""
          );
          const [heightSubValue, setHeightSubValue] = useState( ""
          );

          // Add these states at the top with your other states
const [originalWeight, setOriginalWeight] = useState("");
const [originalHeight, setOriginalHeight] = useState("");
const [originalHeightSub, setOriginalHeightSub] = useState("");
const [originalWeightUnit, setOriginalWeightUnit] = useState('Standard');
const [originalHeightUnit, setOriginalHeightUnit] = useState('Standard');
    
          const [bodyTemp, setBodyTemp] = useState('')
          const [heartRate, setHeartRate] = useState('')
          const [respRate, setRespRate] = useState('')
          const [systolic, setSystolic] = useState('')
          const [distolic, setDistolic] = useState('')
          const [spo2, setSpo2] = useState('')
          const [fastingBloodGlucose, setFastingBloodGlucose] = useState('')
          const [postBloodGlucose, setPostBloodGlucose] = useState('')
    
          // existing function
          // const handleChangeBodyTemperature = (event) => {
          //   let inputValue = event.target.value;
          //   // inputValue = inputValue.replace(/[^A-Za-z0-9\s@.]/g, '').slice(0, 50);
          //   inputValue = inputValue.replace(/[^0-9.]/g, '').slice(0, 50);
          //   event.target.value = inputValue;
          //   setTempValue(event.target.value);
          // };

// newly added function
const validateTemperature = (value, unit) => {
    const numericValue = parseFloat(value);
    
    if (isNaN(numericValue)) {
      return "Please enter a valid number";
    }
    
    if (unit === "°F") {
      if (numericValue < MIN_TEMP_F || numericValue > MAX_TEMP_F) {
        return `Temperature must be between ${MIN_TEMP_F}°F and ${MAX_TEMP_F}°F`;
      }
    } else {
      if (numericValue < MIN_TEMP_C || numericValue > MAX_TEMP_C) {
        return `Temperature must be between ${MIN_TEMP_C.toFixed(1)}°C and ${MAX_TEMP_C.toFixed(1)}°C`;
      }
    }
    
    return "";
  };

  const handleChangeBodyTemperature = (event) => {
    let inputValue = event.target.value;
    
    // Allow empty value
    if (inputValue === "") {
      setTempValue("");
      setError("");
      return;
    }
    
    // Allow only one decimal point and numbers
    inputValue = inputValue.replace(/[^0-9.]/g, '');
    
    // Prevent multiple decimals
    const parts = inputValue.split('.');
    if (parts.length > 2) {
      inputValue = parts[0] + '.' + parts.slice(1).join('');
    }

    // Set the value first, then validate
    setTempValue(inputValue);
    
    // Validate if input is not empty
    if (inputValue !== '') {
      const validationError = validateTemperature(inputValue, tempUnit);
      setError(validationError);
      
      // if (validationError) {
      //   showErrorToast(validationError);
      // }
    } else {
      setError("");
    }
  };
          const handleChangeHeartRate = (event) => {
            let inputValue = event.target.value;
            inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
            event.target.value = inputValue;
            setHeartRate(event.target.value);
          };
          const handleChangeRespiratoryRate = (event) => {
            let inputValue = event.target.value;
            inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
            event.target.value = inputValue;
            setRespRate(event.target.value);
          };
          const handleChangeSystolic = (event) => {
            let inputValue = event.target.value;
            inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
            event.target.value = inputValue;
            setSystolic(event.target.value);
          };
          const handleChangeDistolic = (event) => {
            let inputValue = event.target.value;
            inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
            event.target.value = inputValue;
            setDistolic(event.target.value);
          };
          const handleSP02 = (event) => {
            let inputValue = event.target.value;
            inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
            event.target.value = inputValue;
            setSpo2(event.target.value);
          };
          const handleFastingBloodGlucose = (event) => {
            let inputValue = event.target.value;
            inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
            event.target.value = inputValue;
            setFastingBloodGlucose(event.target.value);
          };
          const handlePostBloodGlucose = (event) => {
            let inputValue = event.target.value;
            inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
            event.target.value = inputValue;
            setPostBloodGlucose(event.target.value);
          };
    
          const openVitalsModal = () => {
  // Reset time and date to current values
  const currentFormattedTime = moment().format("HH:mm");
  const currentFormattedDate = moment().format("DD-MM-YYYY");
  
  setAddTime(currentFormattedTime);
  setAddDate(currentFormattedDate);

  fetchDoctors()
  setTempValue('')
  setHeartRate('')
  setSpo2('')
  setSystolic('')
  setDistolic('')
  setRespRate('')
  setFastingBloodGlucose('')
  setPostBloodGlucose('')
  
  // Reset original values first
  setOriginalWeight("");
  setOriginalHeight("");
  setOriginalHeightSub("");
  setOriginalWeightUnit('Standard');
  setOriginalHeightUnit('Standard');

  // Prepopulate height and weight from patient data
  if (patienData.patientinfo?.weight) {
    setWeightValue(patienData.patientinfo.weight)
    setOriginalWeight(patienData.patientinfo.weight)
    
    const weightUnitValue = patienData.patientinfo.weightunit === 'kg' ? 'Metric' : 'Standard';
    setWeightUnit(weightUnitValue)
    setOriginalWeightUnit(weightUnitValue)
  } else {
    setWeightValue("")
    setOriginalWeight("")
  }
  
  if (patienData.patientinfo?.height) {
    let feet = '';
    let inches = '';
  
    if (patienData.patientinfo.heightunit === 'cms') {
      // Metric height (single value in cm)
      setHeightValue(patienData.patientinfo.height)
      setOriginalHeight(patienData.patientinfo.height)
      setHeightSubValue('')
      setOriginalHeightSub('')
      
      setHeightUnit('Metric')
      setOriginalHeightUnit('Metric')
    } else {
      // Standard height - check for both formats
      if (patienData.patientinfo.height.includes('.')) {
        [feet, inches] = patienData.patientinfo.height.split('.')
      } else if (patienData.patientinfo.height.includes(' ')) {
        [feet, inches] = patienData.patientinfo.height.split(' ')
      } else {
        feet = patienData.patientinfo.height
        inches = '0'
      }
      
      setHeightValue(feet)
      setOriginalHeight(feet)
      setHeightSubValue(inches)
      setOriginalHeightSub(inches)
      
      setHeightUnit('Standard')
      setOriginalHeightUnit('Standard')
    }
  } else {
    setHeightValue("")
    setOriginalHeight("")
    setHeightSubValue("")
    setOriginalHeightSub("")
  }
  
  addVitalData.current.openRight();
}
          // existin function
  //       const openVitalsModal = () => {
  //         // Reset time and date to current values
  // const currentFormattedTime = moment().format("HH:mm");
  // const currentFormattedDate = moment().format("DD-MM-YYYY");
  
  // setAddTime(currentFormattedTime);
  // setAddDate(currentFormattedDate);

  //         fetchDoctors()
  //         setTempValue('')
  //         setHeartRate('')
  //         setSpo2('')
  //         setSystolic('')
  //         setDistolic('')
  //         setRespRate('')
  //         setFastingBloodGlucose('')
  //         setPostBloodGlucose('')
  //         // setWeightValue('')
  //         // setHeightValue('')
  //         // setHeightSubValue('')
    
  //         // Prepopulate height and weight from patient data
  //         if (patienData.patientinfo?.weight) {
  //       setWeightValue(patienData.patientinfo.weight)
  //       setWeightUnit(patienData.patientinfo.weightunit === 'kg' ? 'Metric' : 'Standard')
  //     }
      
  //     if (patienData.patientinfo?.height) {
  //     // Handle both space-separated ("5 9") and decimal ("5.9") formats
  //     let feet = '';
  //     let inches = '';
    
  //     if (patienData.patientinfo.heightunit === 'cms') {
  //       // Metric height (single value in cm)
  //       setHeightValue(patienData.patientinfo.height)
  //       setHeightSubValue('')
  //       setHeightUnit('Metric')
  //     } else {
  //       // Standard height - check for both formats
  //       if (patienData.patientinfo.height.includes('.')) {
  //         // Decimal format (e.g., "6.0")
  //         [feet, inches] = patienData.patientinfo.height.split('.')
  //         // inches = inches === '0' ? '' : inches // Show empty if inches is 0
  //       } else if (patienData.patientinfo.height.includes(' ')) {
  //         // Space-separated format (e.g., "6 0")
  //         [feet, inches] = patienData.patientinfo.height.split(' ')
  //         // inches = inches === '0' ? '' : inches // Show empty if inches is 0
  //       } else {
  //         // Single value (assume feet only)
  //         feet = patienData.patientinfo.height
  //         inches = '0'
  //       }
        
  //       setHeightValue(feet)
  //       setHeightSubValue(inches)
  //       setHeightUnit('Standard')
  //     }
  //   }
  //       //   if(activeSection == 'vitals'){
  //       //     // renderComponent('visits')
  //       //     setActiveSection('vitals')
  //       //   }
  //         addVitalData.current.openRight();
  //       }
    
        const [isButtonDisabled, setIsButtonDisabled] = useState(true);
      
        // existing function
        // const handleTempUnitChange = (newUnit) => {
        //   if (newUnit === "°F") {
        //     if (tempValue) {
        //       if (tempUnit === "°F")
        //         setTempValue((prev) => (prev * 2.20462).toFixed(2));
        //     }
            
        //     setTempUnit("°F");
        //   } else if (newUnit === "°C") {
        //     if (tempValue) {
        //       if (tempUnit === "°C") {
        //         setTempValue((prev) => (prev / 2.20462).toFixed(2));
        //       }
        //     }
            
        //     setTempUnit("°C");
        //   }
        // };

  const handleTempUnitChange = (newUnit) => {
    if (newUnit === tempUnit) return; // No change needed if same unit

    if (tempValue) {
      const numericValue = parseFloat(tempValue);
      
      if (newUnit === "°F") {
        // Convert from °C to °F: (°C × 9/5) + 32
        const convertedValue = (numericValue * 9/5) + 32;
        
        // Validate converted value
        if (convertedValue < MIN_TEMP_F || convertedValue > MAX_TEMP_F) {
          setError(`Converted temperature ${convertedValue.toFixed(1)}°F is outside valid range (${MIN_TEMP_F}°F - ${MAX_TEMP_F}°F)`);
          return; // Don't change unit if conversion results in invalid value
        }
        
        setTempValue(convertedValue.toFixed(1));
      } else {
        // Convert from °F to °C: (°F - 32) × 5/9
        const convertedValue = (numericValue - 32) * 5/9;
        
        // Validate converted value
        if (convertedValue < MIN_TEMP_C || convertedValue > MAX_TEMP_C) {
          setError(`Converted temperature ${convertedValue.toFixed(1)}°C is outside valid range (${MIN_TEMP_C.toFixed(1)}°C - ${MAX_TEMP_C.toFixed(1)}°C)`);
          return; // Don't change unit if conversion results in invalid value
        }
        
        setTempValue(convertedValue.toFixed(1));
      }
    }
    
    setTempUnit(newUnit);
    setError(""); // Clear error when changing unit
  };
    
        const handleUnitChange = (newUnit) => {
      // Convert weight
      if (weightValue) {
        setWeightValue(prev => {
          const numValue = parseFloat(prev);
          if (newUnit === "Standard" && weightUnit === "Metric") {
            return (numValue * 2.20462).toFixed(2); // kg to lbs
          } else if (newUnit === "Metric" && weightUnit === "Standard") {
            return (numValue / 2.20462).toFixed(2); // lbs to kg
          }
          return prev;
        });
      }
    
      // Convert height
      if (heightValue) {
        if (newUnit === "Standard" && heightUnit === "Metric") {
          // cm to ft+in
          const totalInches = parseFloat(heightValue) / 2.54;
          const feet = Math.floor(totalInches / 12);
          const inches = Math.round(totalInches % 12);
          setHeightValue(feet.toString());
          setHeightSubValue(inches.toString());
        } else if (newUnit === "Metric" && heightUnit === "Standard") {
          // ft+in to cm
          const feet = parseFloat(heightValue) || 0;
          const inches = parseFloat(heightSubValue) || 0;
          const totalInches = (feet * 12) + inches;
          setHeightValue((totalInches * 2.54).toFixed(2));
          setHeightSubValue('');
        }
      }
    
      // Update both units together
      setWeightUnit(newUnit);
      setHeightUnit(newUnit);
    };
      
        // const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
        const [date, setDate] = useState(moment().format("yyyy-MM-DD"));
        const [time, setTime] = useState(moment().format("HH:mm"));
    
        const [refreshVitals, setRefreshVitals] = useState(false);
        const fetchVitalsRef = useRef();
      
const SubmitBMIform = async () => {
    
          if (!validateHeightInputs()) {
        return;
      }

      // Temperature validation
  if (tempValue) {
    const numericTemp = parseFloat(tempValue);
    
    if (tempUnit === "°F") {
      if (numericTemp < 89 || numericTemp > 111) {
        showErrorToast("Please enter a proper temperature between 89°F and 111°F");
        return;
      }
    } else {
      // Convert Celsius limits: (89°F = 31.7°C, 111°F = 43.9°C)
      if (numericTemp < 31.7 || numericTemp > 43.9) {
        showErrorToast("Please enter a proper temperature between 31.7°C and 43.9°C");
        return;
      }
    }
  }
    
          // Convert the unit system to specific units before sending
      const weightUnitToSend = weightUnit === 'Standard' ? 'lbs' : 'kg';
      const heightUnitToSend = heightUnit === 'Standard' ? 'ft' : 'cms';

      // Helper function to compare values
  const getValueToSend = (currentValue, originalValue) => {
    if (currentValue === "" || currentValue === null || currentValue === undefined) {
      return "";
    }
    if (currentValue === originalValue) {
      return "";
    }
    return currentValue;
  };

  // Get values to send (empty if unchanged)
  const weightValueToSend = getValueToSend(weightValue, originalWeight);
  const heightValueToSend = getValueToSend(heightValue, originalHeight);
  const heightSubValueToSend = getValueToSend(heightSubValue, originalHeightSub);
    
  let formattedHeightValue = "";
  if (heightValueToSend !== "" || heightSubValueToSend !== "") {
    if (heightUnit === 'Standard') {
      const feet = heightValueToSend || '0';
      const inches = heightSubValueToSend === '' ? '0' : heightSubValueToSend;
      formattedHeightValue = `${feet}.${inches}`;
    } else {
      formattedHeightValue = heightValueToSend || '';
    }
  }
  // existing
      // let formattedHeightValue;
      // if (heightUnit === 'Standard') {
      //   const feet = heightValue || '0';
      //   const inches = heightSubValue === '' ? '0' : heightSubValue;
      //   formattedHeightValue = `${feet}.${inches}`;
      //   // const feet = heightValue ? parseInt(heightValue) : 0;
      //   // const inches = heightSubValue ? parseInt(heightSubValue) : 0;
      //   // formattedHeightValue = `${feet}.${inches}`;
      // } else {
      //   // formattedHeightValue = heightValue ? parseFloat(heightValue).toString() : '';
      //   formattedHeightValue = heightValue || '';
      // }
      
          const inputToSave = {
            input: {
              doctorid: getLoginID(),
              ...(appointmentId && { appointment_id: appointmentId }),
              patientid: patientid,
              updatedby: Doctorid,
        // vitaladdeddate: getLocalISOString(addDate, addTime),
        updateddate: getLocalISOString(addDate, addTime),
              "vitals": [
                {
        vitalname: "Weight",
        vitalvalue: weightValueToSend,
        vitalunit: weightUnitToSend,
        vitaltype_cd: "",
        vitaladdeddate: `${date} ${time}`,
      },
      {
        vitalname: "Height",
        vitalvalue: formattedHeightValue,
        vitalunit: heightUnitToSend,
        vitaltype_cd: "238",
        vitaladdeddate: `${date} ${time}`,
      },
                // {
                //   vitalname: "Weight",
                //   vitalvalue: weightValue,
                //   vitalunit: weightUnitToSend,
                //   vitaltype_cd: "",
                //   vitaladdeddate: `${date} ${time}`,
                // },
                // {
                //   vitalname: "Height",
                //   // vitalvalue: (heightValue && heightSubValue) ? heightValue + "." + heightSubValue : heightValue,
                //   vitalvalue: formattedHeightValue,
                //   // vitalvalue: (heightValue && heightSubValue) ? heightValue + "." + heightSubValue : '',
                //   vitalunit: heightUnitToSend,
                //   vitaltype_cd: "238",
                //   vitaladdeddate: `${date} ${time}`,
                // },
        {
          "vitalname": "Systolic Blood Pressure",
          "vitalvalue": systolic,
          "vitalunit": "mmHg",
          "vitaltype_cd": "",
          vitaladdeddate: appointmentId ? getLocalISOString(addDate, addTime) : `${date} ${time}`
        },
        {
          "vitalname": "Diastolic Blood Pressure",
          "vitalvalue": distolic,
          "vitalunit": "mmHg",
          "vitaltype_cd": "",
          // vitaladdeddate: `${date} ${time}`
          vitaladdeddate: appointmentId ? getLocalISOString(addDate, addTime) : `${date} ${time}`
        },
        {
          "vitalname": "Pulse",
          "vitalvalue": heartRate,
          "vitalunit": "bpm",
          "vitaltype_cd": "",
          // vitaladdeddate: `${date} ${time}`
          vitaladdeddate: appointmentId ? getLocalISOString(addDate, addTime) : `${date} ${time}`
        },
        {
          "vitalname": "Body Temperature",
          "vitalvalue": tempValue,
          "vitalunit": tempUnit,
          "vitaltype_cd": "",
          // vitaladdeddate: `${date} ${time}`
          vitaladdeddate: appointmentId ? getLocalISOString(addDate, addTime) : `${date} ${time}`
        },
        {
          "vitalname": "Respiratory Rate",
          "vitalvalue": respRate,
          "vitalunit": "bpm",
          "vitaltype_cd": "",
          // vitaladdeddate: `${date} ${time}`
          vitaladdeddate: appointmentId ? getLocalISOString(addDate, addTime) : `${date} ${time}`
        },
        {
          "vitalname": "Oxygen Saturation",
          "vitalvalue": spo2,
          "vitalunit": "%",
          "vitaltype_cd": "",
          // vitaladdeddate: `${date} ${time}`
          vitaladdeddate: appointmentId ? getLocalISOString(addDate, addTime) : `${date} ${time}`
        },
        {
          "vitalname": "Fasting Blood Glucose",
          "vitalvalue": fastingBloodGlucose,
          "vitalunit": "mg/dL",
          "vitaltype_cd": "",
          // vitaladdeddate: `${date} ${time}`
          vitaladdeddate: appointmentId ? getLocalISOString(addDate, addTime) : `${date} ${time}`
        },
        {
          "vitalname": "Postprandial Blood Glucose",
          "vitalvalue": postBloodGlucose,
          "vitalunit": "mg/dL",
          "vitaltype_cd": "",
          // vitaladdeddate: `${date} ${time}`
          vitaladdeddate: appointmentId ? getLocalISOString(addDate, addTime) : `${date} ${time}`
        }
      ].filter((vital) => vital.vitalvalue !== ""), 
            },
          };
          if (moment(date, "DD-MM-YYYY", true).isValid()) {
            const formatteddate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
            const vitaldate = formatteddate + " " + time;
          }
          showLoader();
          try {
            if (inputToSave.input.vitals && inputToSave.input.vitals.length > 0) {
              const result = await AddVitalData(inputToSave.input);
              if (result && result.output.message === "Successfully Inserted/Updated") {
                addVitalData.current.closeRight();
                // renderComponent('vitals')
                fetchpatientdata(patientid, appointmentId)
                fetchvitaldata(patientid, appointmentId)
                showSuccessToast("Vitals saved successfully");
                setIsButtonDisabled(true); // Disable button after successful submission
                // setRefreshVitals(prev => !prev);
                // Call the child's function
          if (fetchVitalsRef.current) {
            fetchVitalsRef.current(patientid, appointmentId);
          }
    
              }
              dismissLoader();
            }
            dismissLoader();
      
          } catch (error) {
            console.error("Error in SubmitFunction:", error);
          }
        };
    // ----------------------------- Add Vitals Functionality Ends ----------------------------
    const [bmi, setBmi] = useState(null);
    
            // Function to calculate BMI
            // existing code function
    // const calculateBMI = (weight, height, heightSub, weightUnit, heightUnit) => {
    //   if (!weight || !height) {
    //     setBmi(0);
    //     return;
    //   } 
    
    //   let weightInKg = weightUnit === "lbs" ? weight / 2.20462 : weight; // Convert lbs to kg
    //   let heightInMeters = 0;
    
    //   if (heightUnit === "cms") {
    //     heightInMeters = height / 100; // Convert cm to meters
    //   } else {
    //     // Convert feet and inches to meters
    //     let totalInches = height * 12 + Number(heightSub || 0);
    //     heightInMeters = totalInches * 0.0254;
    //   }
    
    //   if (heightInMeters > 0) {
    //     let bmiValue = weightInKg / (heightInMeters * heightInMeters);
    //     setBmi(bmiValue.toFixed(1));
    //   } else {
    //     setBmi(0);
    //   }
    // };

    // newly added function
    const calculateBMI = (weight, height, heightSub, weightUnit, heightUnit) => {
      if (!weight || !height) {
        setBmi(0);
        return;
      } 
    
      let weightInKg = weightUnit === "lbs" ? weight / 2.20462 : weight; // Convert lbs to kg
      let heightInMeters = 0;

      let bmiValue = 0;
    
      // if (heightUnit === "cms") {
      if (heightUnit === "Metric") {
        heightInMeters = height / 100; // Convert cm to meters
        bmiValue = weight / (heightInMeters * heightInMeters);
      } else {
        // Convert feet and inches to meters
        // let totalInches = height * 12 + Number(heightSub || 0);
        // heightInMeters = totalInches * 0.0254;
        let totalInches = (parseFloat(height) * 12) + (parseFloat(heightSub) || 0);
    bmiValue = (703 * weight) / (totalInches * totalInches);
      }
    
      setBmi(bmiValue > 0 ? bmiValue.toFixed(1) : 0);

      // existing code
      // if (heightInMeters > 0) {
      //   let bmiValue = weightInKg / (heightInMeters * heightInMeters);
      //   setBmi(bmiValue.toFixed(1));
      // } else {
      //   setBmi(0);
      // }
    };
    
    // Call BMI function when height or weight changes
    useEffect(() => {
      calculateBMI(weightValue, heightValue, heightSubValue, weightUnit, heightUnit);
    }, [weightValue, heightValue, heightSubValue, weightUnit, heightUnit]);
    
    const validateHeightInputs = () => {
      if (heightUnit === 'Standard') {
        // For Standard units, feet should be integer, inches between 0-11
        const feet = parseFloat(heightValue) || 0;
        const inches = parseFloat(heightSubValue) || 0;
    
        // if (isNaN(feet) || feet <= 0) {
        //   showErrorToast("Please enter valid feet value");
        //   return false;
        // }
        
        // if (!Number.isInteger(feet)) {
        //   showErrorToast("Feet must be a whole number");
        //   return false;
        // }
    
        // // Check if inches is entered (but allow empty display)
        // if (heightSubValue === '') {
        //   showErrorToast("Please enter inches value");
        //   return false;
        // }
        
        // if (isNaN(inches)) {
        //   showErrorToast("Please enter valid inches value");
        //   return false;
        // }
        
        // if (!Number.isInteger(inches)) {
        //   showErrorToast("Inches must be a whole number");
        //   return false;
        // }
        
        // if (inches < 0 || inches > 11) {
        //   showErrorToast("Inches must be between 0-11");
        //   return false;
        // }
    
        // Check if feet is valid
        if (isNaN(feet) || feet <= 0) {
          showErrorToast("Please enter valid feet value");
          return false;
        }
        
        // Check if feet is whole number
        if (!Number.isInteger(feet)) {
          showErrorToast("Feet must be a whole number");
          return false;
        }
        
        // Check if inches is entered (but allow empty display)
        if (heightSubValue === '') {
          showErrorToast("Please enter inches value");
          return false;
        }
        
        // Check if inches is valid (0-11)
        if (isNaN(inches) || inches < 0 || inches > 11) {
          showErrorToast("Inches must be between 0-11");
          return false;
        }
        
        // if (!Number.isInteger(feet)) {
        //   showErrorToast("Feet must be a whole number");
        //   return false;
        // }
        
        // if (inches < 0 || inches > 11) {
        //   showErrorToast("Inches must be between 0-11");
        //   return false;
        // }
      } else {
        // For Metric units, just check it's a valid number
        // For Metric units (cm)
        const cm = parseFloat(heightValue);
        if (isNaN(cm) || cm <= 0) {
          showErrorToast("Please enter a valid height in centimeters");
          return false;
        }
        // if (isNaN(parseFloat(heightValue))) {
        //   showErrorToast("Please enter a valid height");
        //   return false;
        // }
      }
      return true;
    };

// --------------------- Date TIme & Doctor ------------------------------------
var [DoctorListForDropdown, setDoctorListForDropdown] = useState([]);
var [DoctorList, setDoctorList] = useState([]);
// var [Doctorid, setDoctorId] = useState(null);
var [DefaultDoctor, setDefaultDoctor] = useState(null);

const [addDate, setAddDate] = useState(moment().format("DD-MM-yyyy"));
const [addTime, setAddTime] = useState(moment().format("HH:mm"));

const getLocalISOString = (dateStr, timeStr) => {
  // Parse the date in DD-MM-yyyy format
  const [day, month, year] = dateStr.split("-").map(Number);
  // Parse the time in HH:mm format
  const [hours, minutes] = timeStr.split(":").map(Number);
  
  // Create a Date object in local timezone
  const dateObj = new Date(year, month - 1, day, hours, minutes, 0);
  
  // Format to ISO string with local timezone offset
  const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // offset in milliseconds
  const localISOTime = new Date(dateObj - timezoneOffset).toISOString().slice(0, 19).replace('Z', '');
  
  return localISOTime;
};

const handledatechange = (selectedDate) => {
  const formattedDate = moment(selectedDate).format("DD-MM-yyyy");
  setAddDate(formattedDate);
};

const handleTimeChange = (event) => {
    const inputTime = event.target.value;
    const currentDate = moment().format("DD-MM-yyyy");
    const currentTime = moment().format("HH:mm");
    
    // Only validate if the selected date is today
    if (addDate === currentDate) {
      const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
      const [currentHours, currentMinutes] = currentTime.split(":").map(Number);
  
      // Create moment objects for comparison
      const inputMoment = moment().set({
        hour: inputHours,
        minute: inputMinutes,
        second: 0,
        millisecond: 0
      });
      
      const currentMoment = moment();
  
      if (inputMoment.isAfter(currentMoment)) {
        setAddTime(currentTime);
        showErrorToast("Future time cannot be selected.");
        return;
      }
    }
    
    // If date is not today or time is not in future, update the time
    setAddTime(inputTime);
  };
// existing function
// const handleTimeChange = (event) => {
//   const inputTime = event.target.value;
//   const currentTime = new Date();
//   const [inputHours, inputMinutes] = inputTime.split(":").map(Number);

//   const inputDate = new Date();
//   inputDate.setHours(inputHours);
//   inputDate.setMinutes(inputMinutes);

//   if (inputDate > currentTime) {
//     const currentFormattedTime = moment().format("HH:mm");
//     setAddTime(currentFormattedTime);
//     showErrorToast("Future time cannot be selected.");
//   } else {
//     setAddTime(inputTime);
//   }
// };

const fetchDoctors = async () => {
    showLoader();
    try {
      // const result = await FetchDoctorsByUser({
      const result = await FetchUsersByClinic({
        // doctorid,
        appointmentid: appointmentId
      });

      // console.log('resultofDoctors: ', result)
      if (result.output.result == "success") {
        console.log('result.outptu.data: ', result.output.data)
        setDoctorList(result.output.data);
        const Doctors = result.output.data && result.output.data.map((step) => [
          step.fullname
        ]);
        console.log('Doctors: ', Doctors)
        setDoctorListForDropdown(Doctors);
        const currentdoctor = getIsDoctor();
        console.log('currentdoctor: ', currentdoctor)
        const loginid = getLoginID();
        console.log('getLogin: ', loginid)
        
        let obj = {}
        if (currentdoctor == 1 && currentdoctor != null) {
          obj = result.output.data && result.output.data.filter(doctor => doctor.doctorid == loginid);
          if (obj[0]) {
            console.log('obj[0]: ', obj[0].fullname)
            setDefaultDoctor(obj[0].fullname)
            setDoctorid(loginid)
          }

        } else {
          setDefaultDoctor("");
        }
      } else {
        setDoctorList([]);
        dismissLoader();
      }
      dismissLoader();
    } catch (error) {
      console.error("Error", error);
    }
  };

const HandleEditDoctor = (selectedOption) => {
    let obj = DoctorList.filter(doctor => doctor.fullname == selectedOption);
    // setDoctorid(obj[0].doctorid)
    if (obj.length > 0) {
    setDoctorid(obj[0].doctorid);
    // setSelectedDoctorId(obj[0].doctorid); // Store the selected doctor ID
    setDefaultDoctor(obj[0].fullname);
  }
  }

  return (
    <>
    {isLoading && <Loader />}
      <Box w="100%" display={{base: "none", lg: "block"}}>
        {/* existing code */}
      {/* {isVitals && isVitals === true && (vitalsData && vitalsData.length === 0 ? (
          <NoDataScreen width="100%" height="100%" />
        ) : (
          <ProfileVitalDisplayCard
            vitals={vitalsData}
            patientId={patientid}
            doctorId={doctorid}
            appointmentId={appointmentId}
            showLoader={showLoader}
            dismissLoader={dismissLoader}
          />
        ))} */}

        {/* newly added code */}
        {appointmentId && (
            <Box pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
              <Text fontWeight='600'>Vitals</Text>
              <PrimaryButton
                fontSize="14px"
                variant="mdBtn"
                btnIcon="/assets/imgs/add.png"
                buttonText="Add Vitals"
                onClick={openVitalsModal}
                // isDisabled={actionAccessPatients?.create ? false : true}
              />
            </Box>
            )}
    {isVitals === false ? (
    <>
      {/* {alert("Condition 1: No vitals data available")} */}
      <NoDataVitalsScreen width="100%" height="100%" appointmentId={appointmentId} />
    </>
  ) : (
    <>
      {/* {alert("Condition 2: Vitals data available")} */}
      <ProfileVitalDisplayCard
        vitals={vitalsData}
        patientId={patientid}
        // doctorId={doctorid}
        doctorId={Doctorid}
        appointmentId={appointmentId}
        showLoader={showLoader}
        dismissLoader={dismissLoader}
        showSuccessToast={showSuccessToast}
        showErrorToast={showErrorToast}
        fetchVitalsRef={fetchvitaldata}
      />
    </>
  )}
      </Box>


      <ModalRight
        ref={addVitalData}
        header="Add Vitals"
        bodyStyle={{ p: "24px 32px" }}
        modalWidth="calc(100vw - 50%)"
        body={
          <>
            <Box display="flex" flexDir="column" gap="20px">
          <VStack spacing={4} align="stretch" height="100%">
            {/* Date, Time, Doctor Name*/}

              {/* Date Time & Doctor Field */}
                            <Box display="flex" flexDir="row">
                              <DropdownInput
                                variant="bothSide"
                                dropDownPlace="Doctor Name*"
                                options={DoctorListForDropdown || []}
                                id="Doctor Name"
                                onClick={HandleEditDoctor}
                                value={DefaultDoctor} 
                                defaultOption={DefaultDoctor}
                                menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                                inputStyleCss={{ w: "100%" }}
                              />
                              <DatePicker
                                onDateChange={(selectedDateValue) =>
                                  handledatechange(selectedDateValue)
                                }
                                defaultDate={addDate}                    
                                disableFutureDates={true}
                                placeholderProp="Date"
                                calendarStlye={{left: "-18px",  right: "unset"}}
                              />
                              <PrimaryInput
                                variant="bothSide"
                                id="vitaltime"
                                inputType="time"
                                inputPlace="Time"
                                pr="10px"
                                defaultValue={addTime}
                                inputValue={addTime}
                                onChange={handleTimeChange }
                              />
                            </Box>
            <Divider />
            {/* Row 1 */}

              <Flex direction="row" gap='1rem' align="center" width="100%">
                <Flex direction="column" width="100%">
                  <FormLabel mb="0" width={{ base: "20%", md: "100%" }}>
                    Body Temperature ({tempUnit})
                  </FormLabel>
                  <Flex direction="column" width="100%">
                    <Flex align="center" mb={1} gap={2} >
                      {/* <Box fontSize="xs" fontWeight="bold">
                        {tempUnit}
                      </Box> */}

                      <Select
            value={tempUnit}
            onChange={(e) => handleTempUnitChange(e.target.value)}
            fontSize={"xs"}
            size={"xs"}
            width='max-content'
            bg='white'
            pl='0'
            className="tempUnit"
            borderRadius='8px'
          >
            <option value="°F">°F</option>
            <option value="°C">°C</option>
          </Select>

                      {/* existing */}
                      {/* <Select
                        // value={weightUnit === "lbs" ? "Standard" : "Metric"}
                        value={tempUnit === "°F" ? "°F" : "°C"}
                        onChange={(e) => handleTempUnitChange(e.target.value)}
                        fontSize={"xs"}
                        size={"xs"}
                        width='max-content'
                        // border="none"
                        textAlignLast="left"
                        bg='white'
                        pl='0'
                        className="tempUnit"
                        borderRadius='8px'
                      >
                        <option value="°F">°F</option>
                        <option value="°C">°C</option>
                      </Select> */}
                    </Flex>
                  </Flex>
                </Flex>
                
                <PrimaryInput
        variant="fullRound"
        title="Search by name"
        inputPlace={`Enter value (${tempUnit === "°F" ? `${MIN_TEMP_F}-${MAX_TEMP_F}°F` : `${MIN_TEMP_C.toFixed(1)}-${MAX_TEMP_C.toFixed(1)}°C`})`}
        id="bodyTemperature"
        onChange={handleChangeBodyTemperature}
        inputValue={tempValue}
        maxLength={5}
      />

                        {/* existing */}
                  {/* <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Enter value"
                    id="yourName"
                    onChange={handleChangeBodyTemperature}
                    inputValue={tempValue}
                    maxLength={5}
                  /> */}

                <Flex direction="column" width={{ base: "50%", md: "100%" }}>
                  <FormLabel width={{ base: "100%", md: "100%" }} mb="0px">
                    Heart Rate
                  </FormLabel>
                  <Box fontSize={"xs"} pt="2px">
                    beats per minute
                  </Box>
                </Flex>
                

                <PrimaryInput
                  variant="fullRound"
                  title="Search by name"
                  inputPlace="Enter value"
                  id="yourName"
                  onChange={handleChangeHeartRate}
                  inputValue={heartRate}
                  maxLength={3}
                />
              </Flex>
            <Divider />
            {/* Row 2 */}
              <Flex height="60px" gap='1rem' align="center">
                <Flex direction="column" width="100%">
                  <FormLabel width={{ base: "100%", md: "100%" }} mb="0px">
                    Respiratory Rate
                  </FormLabel>
                  <Box fontSize={"xs"} pt="2px">
                    breaths per minute
                  </Box>
                </Flex>
                  <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Enter value"
                    id="yourName"
                    onChange={handleChangeRespiratoryRate}
                    inputValue={respRate}
                    maxLength={3}
                  />

                {/* Single Label for both Systolic and Diastolic */}
                <Flex direction="column" width="100%">
                  <FormLabel mb="0px">Blood Pressure</FormLabel>
                  <Box fontSize={"xs"} pt="2px">
                    mmHg
                  </Box>
                </Flex>

                {/* Systolic and Diastolic Input Fields Aligned Right */}
                <Box width="100%" textAlign="right">
                  <Flex justify="flex-end" align="center">
                    {/* Systolic Input */}

                  <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Systolic"
                    id="yourName"
                    onChange={handleChangeSystolic}
                    inputValue={systolic}
                    maxLength={3}
                  />

                    <Box mx={2}>/</Box>

                    {/* Diastolic Input */}
                    <PrimaryInput
                      variant="fullRound"
                      title="Search by name"
                      inputPlace="Distolic"
                      id="yourName"
                      onChange={handleChangeDistolic}
                      inputValue={distolic}
                      maxLength={3}
                    />

                  </Flex>
                </Box>
              </Flex>
            <Divider />
            <Flex height="60px" w='50%' align="center">
                <Flex direction="column" width="100%">
                  <FormLabel width="30%" mb="0px">
                    SPO2
                  </FormLabel>
                  <Box fontSize={"xs"} pt="2px">
                    %
                  </Box>
                </Flex>

                  <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Enter value"
                    id="yourName"
                    onChange={handleSP02}
                    inputValue={spo2}
                    maxLength={3}
                  />
              </Flex>
              <Divider />

            {/* Row 6 */}
              <Flex height="60px" gap='1rem' align="center">

<Flex direction="column" width="100%">
                  <FormLabel width="100%" mb="0px">
                    Fasting Blood Glucose
                  </FormLabel>
                  <Box fontSize={"xs"} pt="2px">
                    mg/dL
                  </Box>
                </Flex>
                  <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Enter value"
                    id="yourName"
                    onChange={handleFastingBloodGlucose}
                    inputValue={fastingBloodGlucose}
                    maxLength={3}
                  />

<Flex direction="column" width="100%">
                  <FormLabel width="60%" mb="0px">
                    Postprandial Blood Glucose
                  </FormLabel>
                  <Box fontSize={"xs"} pt="2px">
                    mg/dL
                  </Box>
                </Flex>
                <Box width="100%" textAlign="right">

                  <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Enter value"
                    id="yourName"
                    onChange={handlePostBloodGlucose}
                    inputValue={postBloodGlucose}
                    maxLength={3}
                  />
                </Box>
 
              </Flex>

            <Divider />
                {/* Weight */}
                <Flex direction="row" gap='1rem' align="center" width="100%" >
                  <Flex direction="column" width="100%">
                    <FormLabel mb="0" width={{ base: "20%", md: "100%" }}>
                      {/* Weight ({weightUnit}) */}
                      Weight ({weightUnit === 'Standard' ? 'lbs' : 'Kg'})
                    </FormLabel>
                    <Flex direction="column" width="100%">
                      <Flex align="center" mb={1} gap={2} >
                        {/* <Box fontSize="xs" fontWeight="bold">
                          {weightUnit}
                        </Box> */}
                        <Select
    value={weightUnit} // or heightUnit for the height select
    onChange={(e) => handleUnitChange(e.target.value)}
    fontSize={"xs"}
    size={"xs"}
    bg='white'
    width={{ base: "80px", md: "90px" }}
    textAlignLast="left"
    borderRadius='8px'
  >
    <option value="Standard">Standard</option>
    <option value="Metric">Metric</option>
  </Select>
                        {/* <Select
                          value={weightUnit === "lbs" ? "Standard" : "Metric"}
                          onChange={(e) => handleUnitChange(e.target.value)}
                          fontSize={"xs"}
                          size={"xs"}
                          bg='white'
                          width={{ base: "80px", md: "90px" }}
                          // border="none"
                          textAlignLast="left"
                          borderRadius='8px'
                          className='weightUnit'
                        >
                          <option value="Standard">Standard</option>
                          <option value="Metric">Metric</option>
                        </Select> */}
                      </Flex>
                    </Flex>
                  </Flex>
                  <Box w="100%" textAlign="right">
                    <Input
    type="number"
    value={weightValue}
    placeholder={weightUnit === 'Standard' ? 'lbs' : 'kg'}
    onChange={(e) => setWeightValue(e.target.value)}
    height="48px"
    width='100%'
    p="0 10px"
    bg={"white"}
    textAlign={"center"}
    ml="auto"
  />
                    {/* <Input
                      type="number"
                      value={weightValue}
                      // placeholder={weightUnit}
                      placeholder={weightUnit === 'Standard' ? 'lbs' : 'kg'}
                      onChange={(e) => setWeightValue(e.target.value)}
                      // height="40px"
                      // p="0 10px"
                      // width={{ base: "100px", md: "150px" }}
                      height="48px"
                      width='100%'
                      p="0 10px"
                      bg={"white"}
                      textAlign={"center"}
                      ml="auto"
                    /> */}
                  </Box>

                  <Flex direction="column" width="100%">
                    <FormLabel mb="0" width={{ base: "20%", md: "100%" }}>
                      {/* Height ({heightUnit}) */}
                      Height ({heightUnit === 'Standard' ? 'ft' : 'cms'})
                    </FormLabel>
                    <Flex direction="column" width="100%">
                      <Flex align="center" mb={1} gap={2} >
                        {/* <Box fontSize="xs" fontWeight="bold">
                          {heightUnit}
                        </Box> */}
                        <Select
                          // value={heightUnit === "ft" ? "Standard" : "Metric"}
                          value={heightUnit}
                          onChange={(e) => handleUnitChange(e.target.value)}
                          // defaultValue={heightUnit}
                          fontSize={"xs"}
                          size={"xs"}
                          bg='white'
                          width={{ base: "80px", md: "90px" }}
                          // border="none"
                          textAlignLast="left"
                          borderRadius='8px'
                          className="heightUnit"
                        >
                          <option value="Standard">Standard</option>
                          <option value="Metric">Metric</option>
                        </Select>
                      </Flex>
                    </Flex>
                  </Flex>
                  <Flex justify="flex-end" w='100%' align="center" gap={2}>
                    <Input
      type="number"
      value={heightValue}
      placeholder={heightUnit === 'Standard' ? 'ft' : 'cms'}
  //     onChange={(e) => {
  //   const value = e.target.value;
  //   // Prevent decimal input in feet when in Standard mode
  //   if (heightUnit === 'Standard' && value.includes('.')) {
  //     return;
  //   }
  //   setHeightValue(value);
  // }}
  onChange={(e) => {
      const value = e.target.value;
      // For Standard units, only allow whole numbers
      if (heightUnit === 'Standard') {
        // if (value.includes('.') || isNaN(parseInt(value))) {
        //   return;
        // }
        // setHeightValue(value ? parseInt(value).toString() : '');
        if (value.includes('.') || isNaN(parseInt(value))) return;
        setHeightValue(value ? parseInt(value).toString() : '');
      } else {
        // For Metric units, allow decimals
        setHeightValue(value);
      }
    }}
      // onChange={(e) => setHeightValue(e.target.value)}
      height="48px"
      p="0 10px"
      width={heightUnit === 'Standard' ? '50%' : '100%'}
      bg={"white"}
      textAlign={"center"}
    />
    {heightUnit === 'Standard' && (
      <>
        <Box>.</Box>
        <Input
          type="number"
          value={heightSubValue}
          placeholder="in"
          // onChange={(e) => setHeightSubValue(e.target.value)}
        //   onChange={(e) => {
        //   const value = e.target.value;
        //   // Only allow whole numbers between 0-11
        //   // if (isNaN(parseInt(value)) || parseInt(value) < 0 || parseInt(value) > 11) {
        //   //   return;
        //   // }
        //   // setHeightSubValue(value ? parseInt(value).toString() : '');
        //   if (value && (isNaN(parseInt(value)) || parseInt(value) < 0 || parseInt(value) > 11)) return;
        //   setHeightSubValue(value);

        // }}
        onChange={(e) => {
          const value = e.target.value;
          // Allow empty but validate on submit
          if (value === '') {
            setHeightSubValue('');
            return;
          }
          // Validate number if entered
          if (isNaN(parseInt(value)) || parseInt(value) < 0 || parseInt(value) > 11) return;
          setHeightSubValue(parseInt(value).toString());
        }}
  //         onChange={(e) => {
  //   const value = e.target.value;
  //   // Limit inches to 11 (0-11)
  //   if (parseInt(value) > 11) {
  //     return;
  //   }
  //   setHeightSubValue(value);
  // }}
          height="48px"
          p="0 10px"
          width='50%'
          bg={"white"}
          textAlign={"center"}
        />
      </>
    )}
                    {/* <Input
                      type="number"
                      value={heightValue}
                      defaultValue={heightValue}
                      // placeholder={heightUnit}
                      placeholder={heightUnit === 'Standard' ? 'ft' : 'cm'}
                      onChange={(e) => setHeightValue(e.target.value)}
                      height="48px"
                      p="0 10px"
                      width='50%'
                      bg={"white"}
                      textAlign={"center"}
                    />
                    {heightUnit === 'Standard' && (
                      <>
                    <Box>.</Box>
                    <Input
                      type="number"
                      value={heightSubValue}
                      // placeholder={heightUnit === "ft" ? "in" : "mm"}
                      // placeholder={heightUnit === 'Standard' ? 'in' : 'mm'}
                      placeholder="in"
                      onChange={(e) => setHeightSubValue(e.target.value)}
                      height="48px"
                      p="0 10px"
                      width='50%'
                      bg={"white"}
                      textAlign={"center"}
                    />
                    </>
                    )} */}
                  </Flex>
                </Flex>

                <Flex direction="row" align="center" pr='1rem' justifyContent='center' width="100%" >
                  <Box w="100%" textAlign="right">
                      <Text fontSize='0.875rem' fontWeight='600'>BMI (Calculated): {bmi || '0'} </Text>
                      {/* <Text fontSize='0.875rem' fontWeight='600'>BMI (calculated): {calculatedBMI || 0}</Text> */}
                      {/* <Text fontSize='0.875rem' fontWeight='600'>{calculatedBMI || 0}</Text> */}
                  </Box>
                </Flex>

              <Divider />
                {/* <Flex height="60px" w='50%' align="center">
                  <Flex direction="column" width="100%">
                    <FormLabel width="30%" mb="0px">
                      SPO2
                    </FormLabel>
                    <Box fontSize={"xs"} pt="2px">
                      %
                    </Box>
                  </Flex>

                    <PrimaryInput
                      variant="fullRound"
                      title="Search by name"
                      inputPlace="Enter value"
                      id="yourName"
                      onChange={handleSP02}
                      inputValue={spo2}
                      maxLength={3}
                    />
                </Flex> */}
            </VStack>
              </Box>
            </>
          }
          footerActions={
            <>
              <Box w="100%" display="flex" flexDirection="row" gap="15px">

  <PrimaryButton
                type="submit"
                onClick={() => {
                  SubmitBMIform();
                }}
                buttonText="Save Vitals"
                // isDisabled={
                //   //(isButtonDisabled && !heightValue && !weightValue) ||
                // //   !actionAccessMain(19)?.create
                // }
              />
              </Box>
            </>
          }
        />

      {/* Mobile responsive */}
      <Box w="100%" display={{base: "block", lg: "none"}}>
        <MobileSecondaryNav
          header="Vitals"
          handlebackarrow={backFunction}
        />
        <Box h="calc(100vh - 120px)" overflow="hidden auto" p="1rem">
        {vitalsData && vitalsData.length>0 ? (
          
          <SimpleGrid  columns={2} gridGap="1rem">
          {vitalsData.map((vital,index) => (
          <Box border="1px solid #E6E7E9"  borderRadius="0.75rem" bg="white" p={4}>
            <Text fontSize="12px" fontWeight="500" color="#6A707D">
              {vital.vitalname}
            </Text>
            <Text display="inline-block" fontSize="22px" fontWeight="600">
              {/* 98.6 */}
              {vital.vitalvalue}
            </Text>
            <Text
              display="inline-block"
              fontSize="15px"
              pl={"5px"}
              fontWeight="400"
            >
              {/* °F */}
              {vital.vitalunit}
            </Text>
            <Box display="flex" justifyContent="space-between">
                <Box>
                <Text fontSize="12px" fontWeight="500" color="#6A707D">
                    {/* May 15, 2024 */}
                    {formatDate(vital.vitaladdeddate)}
                </Text>
                </Box>
                <Box display="flex" alignItems="center" mt="0.5rem" gap="0.25rem">
                  {
                    vital.status === 'High' ? (
                      <>
                      <Image w="12px" h="auto" color='#F04438' src="/assets/imgs/arrow_upward.png" />
                      <Text as="span" fontSize="12px" fontWeight="600" ml="2px" color='#F04438'>{vital.status}</Text>
                      </>
                    ) : vital.status === 'Normal' ? (
                      <>
                      <Image w="12px" h="auto" color='#6A707D' src="/assets/imgs/check.png" />
                      <Text as="span" fontSize="12px" fontWeight="600" ml="2px" color='#6A707D'>{vital.status}</Text>
                      </>
                    ) : vital.status === 'normal' ? (
                      <>
                      <Image w="12px" h="auto" color='#6A707D' src="/assets/imgs/check.png" />
                      <Text as="span" fontSize="12px" fontWeight="600" ml="2px" color='#6A707D'>{vital.status}</Text>
                      </>
                    ) : vital.status === 'Low' ? (
                      <>
                      <Image w="12px" h="auto" color='#D46F11' src="/assets/svgs/arrow_upward.svg" />
                      <Text as="span" fontSize="12px" fontWeight="600" ml="2px" color='#D46F11'>{vital.status}</Text>
                      </>
                    ): ('')
                  }
                </Box>
            </Box>
          </Box>
        ))}
        </SimpleGrid>
        ) : (
          <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            gap="10px"
                            alignItems="center"
                            h="calc(100vh - 100px)"
                          >
                            <Box textAlign="left" fontSize="16px" fontWeight="600">
                              <Image
                                w="26px"
                                opacity="0.5"
                                src="/assets/imgs/heart.png"
                              />
                            </Box>
                            <Text textAlign="left" fontSize="12px" fontWeight="500">
                              No Data available
                            </Text>
                          </Box>
        )}
        </Box>
      </Box>
    </>
  );
};

export default PatientVitalsIndex;
